const formSteps = document.querySelector('.form-steps');
const form = document.querySelector('.form');
const progress = document.querySelectorAll('.step');
const prevBtn = document.querySelectorAll('.back');
const nextBtn = document.querySelectorAll('.next');

let currentStep = 0;

// show the current step
function showStep(stepIndex) {
    const fieldsets = form.querySelectorAll('fieldset');
    fieldsets.forEach((fieldset) => {
        fieldset.classList.remove('active');
    });
    fieldsets[stepIndex].classList.add('active');
    updateProgressBar(stepIndex);
}

// update the progress bar
function updateProgressBar(currentStep) {
    progress.forEach((step, index) => {
        if (index <= currentStep) {
            step.classList.add('active');
        } else {
            step.classList.remove('active');
        }
    });
}

function fromURL() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const step = urlParams.get('step')
    const step1_option = urlParams.get('step1_option')
    const step2_option = urlParams.get('step2_option')


    if (step != null) {
        currentStep = parseInt(step) - 1
        document.querySelectorAll('.form_step').forEach((step) => {
            step.classList.remove('active')
        })
        document.querySelector('.form_step.step' + step).classList.add('active')
    }

    if (step1_option != null) {
        document.querySelectorAll('.form_step.step1 .option').forEach((option) => {
            option.classList.remove('active')
        })
        document.querySelectorAll('.form_step.step1 .option')[(step1_option - 1)].classList.add('active')
    }

    if (step2_option != null) {
        document.querySelectorAll('.form_step.step2 .option').forEach((option) => {
            option.classList.remove('active')
        })
        document.querySelectorAll('.form_step.step2 .option')[(step2_option - 1)].classList.add('active')
    }
}

// go to the previous step
function prevStep() {
    if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
    }
}

// go to the next step
function nextStep() {
    if (currentStep < progress.length - 1) {
        currentStep++;
        showStep(currentStep);
    }
}

// go back to home
function backToHome() {
    formSteps.style.display = 'none';
    // add your own code to redirect to the home page or hide the form
}

function selectOption(optionSelected, step_number) {
    document.querySelector('.form .step' + step_number).querySelectorAll('.option').forEach((option) => {
        option.classList.remove('active')
    })
    optionSelected.classList.add('active')
    updateCurrentSelectedOffer()
    showBadge();
    showMention();
    showMentionText();
}

function updateCurrentSelectedOffer() {
    var first_key = document.querySelectorAll('.form_step .option.active')[0].dataset.combinaisonKey
    var second_key = document.querySelectorAll('.form_step .option.active')[1].dataset.combinaisonKey
    document.querySelectorAll('.issue').forEach((issue) => {
        if (issue.dataset.combinaisonKey == first_key + second_key) {
            issue.classList.add('active')
        } else {
            issue.classList.remove('active')
        }
    });
}

function getCurrentSelectedOfferID() {
    return parseInt(document.querySelector('.issue.active').dataset.variantId)
}

function getCurrentSelectedOfferPlanID() {
    return parseInt(document.querySelector('.issue.active').dataset.sellingplanId)
}

function showPopup() {
    document.getElementById("form-popup").style.display = "flex";
}

function closePopup() {
    document.getElementById("form-popup").style.display = "none";
}

function takeOffer(offer) {
    closePopup()
    document.querySelector('.form_step.step2').querySelector('.option[data-combinaison-key="' + offer + '"]').click()
    checkout('')
}


function checkoutWithNoUpsell() {
    checkout('')
    /*
    let formData = {
        'items': [{
            'id': getCurrentSelectedOfferID(),
            'selling_plan': getCurrentSelectedOfferPlanID(),
            'quantity': 1
        }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            location.href = '/checkout';
            return response.json();
        })
        .catch((error) => {
            // console.error('Error:', error);
        });*/
}

function checkout(popup_id = null) {
    var popupTriggered = false
    if (popup_id != null && !document.querySelector('.next-checkout').classList.contains('popupTriggered')) {
        document.querySelectorAll('.form_step').forEach((step) => {
            if (step.querySelector('.option.active') != null && step.querySelector('.option.active').dataset.combinaisonKey == popup_id) {
                showPopup()
                popupTriggered = true
                document.querySelector('.next-checkout').classList.add('popupTriggered')
            }
        })
    }

    if (!popupTriggered) {
        let formData = {
            'items': [{
                'id': getCurrentSelectedOfferID(),
                'selling_plan': getCurrentSelectedOfferPlanID(),
                'quantity': 1
            }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                location.href = '/checkout';
                return response.json();
            })
            .catch((error) => {
                // console.error('Error:', error);
            });
    }
}

function showBadge() {
    document.querySelectorAll('.option-badge, .popup-badge').forEach((badge) => {
        badge.classList.remove('active')
    })
    document.querySelector('.option-badge[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
    document.querySelector('.popup-badge[data-condition="' + document.querySelector('.form .step1 .option.active').dataset.combinaisonKey + '"]').classList.add('active')
}

function showMentionText() {
    document.querySelectorAll('.option-mention').forEach((mention) => {
        mention.classList.remove('active');
    });
    const activeOption = document.querySelector('.form .step1 .option.active');
    if (!activeOption) return;
    const key = activeOption.dataset.combinaisonKey;
    document.querySelectorAll(`.option-mention[data-condition="${key}"]`).forEach((mention) => {
        mention.classList.add('active');
    });
}

function showMention() {
    const activeOption = document.querySelector('.form .step1 .option.active');
    if (!activeOption) return;
    const key = activeOption.dataset.combinaisonKey;

    document.querySelectorAll('.popup-mention, .title-popup-titre, .title-popup-description').forEach((el) => {
        el.classList.remove('active');
    });

    document.querySelector(`.popup-mention[data-condition="${key}"]`)?.classList.add('active');
    document.querySelector(`.title-popup-titre[data-condition="${key}"]`)?.classList.add('active');
    document.querySelector(`.title-popup-description[data-condition="${key}"]`)?.classList.add('active');
}


// initialize the form
function initForm() {
    showStep(currentStep);

    document.querySelector('.form .step1').querySelectorAll('.option')[0].classList.add('active')
    document.querySelector('.form .step2').querySelectorAll('.option')[1].classList.add('active')

    prevBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            prevStep();
        });
    });

    nextBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            nextStep();
        });
    });
    updateCurrentSelectedOffer();
    showBadge()
    showMention()
    showMentionText()
    fromURL()
}

initForm();
